import type { CSSProperties } from "react";

/**
 * The platform's tab row: labels on a hairline rule, the active one in the
 * tenant's action colour over a short underline.
 *
 * Extracted from the Favorites Manager, which is where the style was set and
 * which every other tab row on the platform is measured against. The Audience
 * Layer's Moments and Community panels carry their own copy of these values,
 * and have to: they are a Module Federation remote in a separate repository
 * and cannot import from here.
 *
 * INLINE STYLES, NOT TAILWIND CLASSES, and that is not a preference. Bootstrap
 * ships an unlayered `* { padding: 0 }` reset on a 15px root that outranks
 * Tailwind's utilities layer inside `.v2`, so `py-3` and friends resolve to
 * zero here. See src/v2/styles/v2.css.
 */
export const tabRowStyle: CSSProperties = {
  display: "flex",
  borderBottom: "1px solid #e2e8f0",
  gap: "32px",
};

export function tabButtonStyle(isActive: boolean): CSSProperties {
  return {
    position: "relative",
    paddingBottom: "12px",
    paddingTop: "4px",
    fontSize: "13px",
    fontWeight: 700,
    letterSpacing: "0.05em",
    border: "none",
    background: "transparent",
    color: isActive ? "var(--v2-action)" : "var(--v2-muted-foreground)",
    cursor: "pointer",
    outline: "none",
  };
}

/**
 * Sits one pixel below the row's rule so it covers it rather than stacking on
 * top of it, which is what makes the active tab read as connected to its panel.
 */
export const activeUnderlineStyle: CSSProperties = {
  position: "absolute",
  bottom: "-1px",
  left: 0,
  width: "100%",
  height: "2.5px",
  backgroundColor: "var(--v2-action)",
  borderRadius: "2px 2px 0 0",
};
